import React from 'react';
import { OutlineButton } from '@/ui/components/OutlineButton';

interface DateHeaderWithButtonProps {
  headerText: string;
  entryId: string;
  isChronologyActive: boolean;
  onSlotClick: (entryId: string) => void;
}

export const DateHeaderWithButton: React.FC<DateHeaderWithButtonProps> = ({
  headerText,
  entryId,
  isChronologyActive,
  onSlotClick,
}) => {
  return (
    <div className="flex items-center justify-between py-2 font-semibold">
      <div>{headerText}</div>
      {isChronologyActive && (
        <OutlineButton
          label="Slot into earlier records"
          className="!h-[32px] !bg-white !text-[14px]"
          onClick={() => onSlotClick(entryId)}
        />
      )}
    </div>
  );
};
